import {
	type PlanOfCareReviewViewModel,
	getPlanOfCareReviewOptions,
	getPatientOptions,
	getPatientAddressesOptions,
	getAdmissionOptions,
	getPatientInsuranceOptions
} from '@generated';
import { useQueryClient } from '@tanstack/react-query';

export function useGetCertificationPeriodReviewOptions(planOfCareReviewId: string) {
	const queryClient = useQueryClient();
	return getPlanOfCareReviewOptions(planOfCareReviewId, (result: PlanOfCareReviewViewModel) => {
		if (!result.data) {
			return;
		}
		queryClient.setQueryData(getPatientOptions(result.data.patient.id).queryKey, result.data.patient);
		queryClient.setQueryData(getPatientAddressesOptions(result.signature.certificationPeriod.stayId).queryKey, result.data.address);
		queryClient.setQueryData(getAdmissionOptions(result.signature.certificationPeriod.stayId).queryKey, result.data.admission);
		queryClient.setQueryData(getPatientInsuranceOptions(result.data.patient.id).queryKey, result.data.insurance);
	});
}
